import { getItem } from './persistentStorage';

declare global {
  interface Window {
    Rubicon: {
      environment: {
        getEnvironment: () => string;
        getApiBaseUrl: () => string;
        getApiOldUrl: () => string;
        getInsightsApiBaseUrl: () => string;
        getInsightsReportingApiBaseURL: () => string;
        getAugustusApiBaseURL: () => string;
      };
      user: {
        setUserInfo: (user: any) => void;
        userInfo: any;
      };
      vendor: {
        setVendorInfo: (user: any) => void;
        vendorInfo: any;
      };
    };
  }
}

const env = window.Rubicon.environment;

export const getBaseUrl = () => window.location.host;
export const getEnvironment = () => env.getEnvironment();
export const getApiBaseURL = () => import.meta.env.VITE_API_URL;
export const getInsightsReportingApiBaseURL = () => import.meta.env.VITE_INSIGHTS_REPORTING_API_URL;
export const getMapboxApiKey = () => import.meta.env.VITE_MAPBOX_API_KEY;
export const getGoogleMapApiKey = () => import.meta.env.VITE_GOOGLE_MAP_API_KEY;
export const getMapboxMonochromeThemeUrl = () => import.meta.env.VITE_MAPBOX_MONOCHROME_THEME_URL;
export const getMapboxSatelliteThemeUrl = () => import.meta.env.VITE_MAPBOX_SATELLITE_THEME_URL;
export const getCustomerCoreApiBaseURL = () => import.meta.env.VITE_CUSTOMER_CORE_API_URL;
export const getCommunicationApiUrl = () => import.meta.env.VITE_COMMUNICATION_API_URL;

export const getIsInMaintenanceMode = () =>
  !getItem('disableMaintenanceMode') && !!import.meta.env.REACT_APP_MAINTENANCE_MODE;
